
import { Button } from "@/components/ui/button";

const StatusCell = ({ status }: { status: string }) => {

     if(status === undefined || status === null) {
          return ""
      }
  // Define a color class based on status
  const getColorClass = (status: string) => {


    switch (status?.toLowerCase()) {
      case "incomplete":
        return "bg-orange-400 hover:bg-orange-500";
      case "active":
        return "bg-emerald-500 hover:bg-emerald-600";
      case "pending":
        return "bg-yellow-500 hover:bg-yellow-600";
      case "completed":
        return "bg-green-500 hover:bg-green-600";
      case "clicked":
        return "bg-blue-500 hover:bg-blue-600";
      default:
        return "bg-gray-300 hover:bg-gray-400";
    }
  };

  return (
    <>
      <Button className={`w-[6rem] ${getColorClass(status)} text-white`}>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </Button>
    </>
  );
};

export default StatusCell;
